export default __webpack_public_path__ + "static/media/6.298bc8c0.jpg";